import { useMemo } from "react";
import { apiGet } from "../utils/apiClient";

/**
 * Retrieves trade reason data.
 * @returns - A promise that resolves to the trade reason data.
 */
export const useFetchTradeReasons = () => {
  const memoizedFetchTradeReasons = useMemo(
    () => async () => {
      return apiGet("/tradeReasons", "fetching trade reasons");
    },
    []
  );

  return memoizedFetchTradeReasons;
};
